// src/pages/FatorConversao/index.jsx
import React, { useEffect, useState, useCallback } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import TableCard from "../../../components/TableCard";
import ResumoCreditosPlanilha from "./ResumoCreditosPlanilha";
import { Box, Autocomplete, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { buscarComboPorCodigo } from '../../../services/auth.service';
import PollIcon from "@mui/icons-material/Poll";
import SnackBar from "../../../components/SnackBar";
import BlueButton from "../../../components/BlueButton";
import WhiteButton from "../../../components/WhiteButton";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import SendIcon from "@mui/icons-material/Send";
import Loading from "../../../components/Loading";
import { keyframes } from "@emotion/react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Fab,
  Grid,
  TextField,
} from "@mui/material";
import { debounce } from "lodash";

// Ajuste o import abaixo para o seu serviço real
import {
  obterFatorConversao,
  cadastrarFatorConversao,
  atualizarFatorConversao,
} from "../../../services/api-empresas.service";

const cleanOnlyDigits = (value) => {
  if (!value && value !== 0) return "";
  return String(value).replace(/\D/g, "");
};

const PERDCOMP = ({ initialData }) => {
  const [dataTable, setDataTable] = useState([]);
  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [grupoEmpresaSelecionado, setGrupoEmpresaSelecionado] = useState({ GE: null, CNPJ: null });
  const [optionsGrupoEmpresas, setOptionsGrupoEmpresas] = useState({ GE: [], CNPJ: [] });

  const [textoBusca, setTextoBusca] = useState("");
  const [objSnackBar, setObjSnackBar] = useState({ type: "", msg: "" });

  const [openModalForm, setOpenModalForm] = useState(false);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [formFornecedor, setFormFornecedor] = useState("");
  const [formCodigoProduto, setFormCodigoProduto] = useState("");
  const [formEAN, setFormEAN] = useState("");
  const [formFator, setFormFator] = useState("");

  const [cnpjSelecionado, setCnpjSelecionado] = useState(""); // agora guardamos o CNPJ limpo (apenas dígitos)
  const [idGrupoEconomico, setIdGrupoEconomico] = useState(null);

  const columns = ["Fornecedor", "Código Produto", "EAN", "Fator"];

  const handleSnackBar = (obj) => setObjSnackBar(obj);

  const fetchFatorConversao = async (cnpj, texto = "") => {
    if (!cnpj) {
      setDataTable([]);
      return;
    }
    try {
      setLoading(true);
      const resp = await obterFatorConversao(cnpj, texto);
      // ajusta conforme o formato da sua API
      const fatoresArray = resp?.fatores ?? resp?.data ?? resp ?? [];
      setRawData(fatoresArray);

      const organized = fatoresArray.map((item) => {
        return {
          fornecedor: item.fornecedor ?? item.nomeFornecedor ?? "",
          codigoProduto: item.cprod ?? "",
          ean: item.ean ?? "",
          fator: (item.fator ?? "").toString(),
          botoes: [
            {
              icon: <EditIcon />,
              title: "EDITAR",
              onClick: () => openEditModal(item),
            },
          ],
        };
      });

      setDataTable(organized);
    } catch (error) {
      console.error("Erro obterFatorConversao:", error);
      setDataTable([]);
      setObjSnackBar({
        type: "error",
        msg:
          error?.response?.data?.mensagem ||
          error?.response?.data?.message ||
          "Erro ao buscar fatores",
      });
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = useCallback(
    debounce((value, cnpj) => {
      fetchFatorConversao(cnpj, value);
    }, 500),
    []
  );

  const handleDebounce = (value) => {
    setTextoBusca(value);
    const cnpj = cnpjSelecionado || ""; // usamos sempre o cnpj limpo do state
    if (!cnpj) {
      setObjSnackBar({
        type: "error",
        msg: "Selecione uma empresa antes de pesquisar fatores.",
      });
      return;
    }
    debouncedFetch(value, cnpj);
  };

  const handleGrupoEmpresa = (grupoObj) => {
    setGrupoEmpresaSelecionado(grupoObj || { GE: null, CNPJ: null });
    const geId = grupoObj?.GE?.id ? Number(grupoObj.GE.id) : null;
    const cnpjRaw = grupoObj?.CNPJ?.detalhes || (grupoObj?.CNPJ?.id ? String(grupoObj.CNPJ.id) : "");
    const cnpjClean = cleanOnlyDigits(cnpjRaw);
    setIdGrupoEconomico(geId);
    setCnpjSelecionado(cnpjClean);
    if (cnpjClean) fetchFatorConversao(cnpjClean, textoBusca); else setDataTable([]);
  };

  const handleCombos = async (codCombo) => {
    try {
      const response = await buscarComboPorCodigo(codCombo);
      const itens = response?.detalhes?.itensCombo || [];
      const parsed = itens.filter(Boolean).map((item) => {
        const split = item.split("/|/");
        return { id: split[0], detalhes: split[1] };
      });
      // remove duplicados por detalhes
      return parsed.filter((c, i, self) => i === self.findIndex(t => t.detalhes === c.detalhes));
    } catch (e) {
      console.error('Erro buscar combos', codCombo, e);
      return [];
    }
  };

  useEffect(() => {
    // carrega grupos econômicos
    (async () => {
      const grupos = await handleCombos('GRUPOECONOMICO');
      setOptionsGrupoEmpresas((prev) => ({ ...prev, GE: grupos }));
    })();
  }, []);

  useEffect(() => {
    // carrega empresas quando GE muda
    (async () => {
      if (!grupoEmpresaSelecionado.GE?.id) return;
      const empresas = await handleCombos(`EMPRESA_POR_GRUPO_TABLECARD_${grupoEmpresaSelecionado.GE.id}`);
      const empresasMask = empresas.map(item => ({
        ...item,
        detalhes: item.detalhes.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      }));
      setOptionsGrupoEmpresas((prev) => ({ ...prev, CNPJ: empresasMask }));
    })();
  }, [grupoEmpresaSelecionado.GE]);

  const openEditModal = (item) => {
    setIsEdit(true);
    setSelectedItem(item);
    setFormFornecedor(item.fornecedor ?? "");
    setFormCodigoProduto(item.cprod ?? "");
    setFormEAN(item.ean ?? "");
    setFormFator(item.fator ?? "");
    setOpenModalForm(true);
  };

  const openDeleteModal = (item) => {
    setSelectedItem(item);
    setOpenModalDelete(true);
  };

  const openInsertModal = () => {
    setIsEdit(false);
    setSelectedItem(null);
    setFormFornecedor("");
    setFormCodigoProduto("");
    setFormEAN("");
    setFormFator("");
    setOpenModalForm(true);
  };

  const closeFormModal = () => {
    setOpenModalForm(false);
    setSelectedItem(null);
    setIsEdit(false);
  };

  const closeDeleteModal = () => {
    setOpenModalDelete(false);
    setSelectedItem(null);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (!cnpjSelecionado) {
      setObjSnackBar({ type: "error", msg: "Selecione uma empresa antes de salvar." });
      return;
    }
    if (!formFornecedor || !formCodigoProduto || !formFator) {
      setObjSnackBar({ type: "error", msg: "Fornecedor, código e fator são obrigatórios." });
      return;
    }

    try {
      setLoading(true);
      const payload = {
        fornecedor: formFornecedor,
        codigoProduto: formCodigoProduto,
        ean: formEAN || null,
        fator: Number(String(formFator).replace(",", ".")),
        // aqui enviamos o CNPJ completo limpo (apenas números)
        cnpj: cnpjSelecionado,
      };

      let resp;
      console.log(selectedItem);
      console.log(payload);
      if (isEdit && selectedItem?.id) {
        resp = await atualizarFatorConversao({ ...payload, id: selectedItem.id });
      } else {
        resp = await cadastrarFatorConversao(payload);
      }

      setObjSnackBar({
        type: "success",
        msg: resp?.mensagem || resp?.message || "Operação realizada com sucesso.",
      });

      await fetchFatorConversao(cnpjSelecionado, textoBusca);
      closeFormModal();
    } catch (error) {
      console.error("Erro salvar fator:", error);
      setObjSnackBar({
        type: "error",
        msg: error?.response?.data?.mensagem || error?.response?.data?.message || "Erro ao salvar",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // se vier initialData, tentamos pegar o CNPJ preferencialmente (campo `cnpj`).
    // se não existir, usamos idEmpresa como fallback (limpando também).
    if (initialData) {
      const raw = initialData.cnpj ?? initialData.idEmpresa ?? "";
      const cnpjClean = cleanOnlyDigits(raw);
      if (cnpjClean) {
        setCnpjSelecionado(cnpjClean);
        fetchFatorConversao(cnpjClean, textoBusca);
      } else {
        setDataTable([]);
      }
    } else {
      setDataTable([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialData]);

  const pulse = keyframes`
      0% { transform: scale(1); }
      50% { transform: scale(1.08); }
      100% { transform: scale(1); }
  `;

  return (
    <>
      {/* <TableCard
        iconHeader={<PollIcon fontSize="1rem" />}
        titleHeader="PERDCOMP"
        data={dataTable}
        setData={setDataTable}
        columns={columns}
        textHeaderCard="fornecedor"
        handleDebounce={handleDebounce}
        temInsert={false}
        handleGrupoEmpresa={handleGrupoEmpresa}
        hasEmpresa={true}
        uniqueEmpresa={true}
        loading={loading}
      /> */}

      <Box sx={{ mt: 3, mx: 'auto', maxWidth: 1650, px: 3 }}>
        <Box sx={{ bgcolor: '#fff', borderRadius: 1, boxShadow: '0 2px 6px rgba(0,0,0,0.08)', p: 2.5 }}>
          {/* Header / título */}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent:'space-between', gap: 2, mb: 2 }}>
            <Box sx={{ fontSize: 24, fontWeight: 600, color: '#18316e', fontFamily: 'Abhaya Libre, Roboto, sans-serif' }}>PERDCOMP</Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems:'flex-start' }}>
              {/* Grupo Econômico */}
              <Autocomplete
                value={grupoEmpresaSelecionado.GE}
                size="small"
                sx={{ minWidth: 260, '& .MuiOutlinedInput-root': { borderRadius: '50px' } }}
                options={optionsGrupoEmpresas.GE}
                isOptionEqualToValue={(o,v)=>o.id===v.id}
                getOptionLabel={(o)=>o.detalhes || ''}
                onChange={(_,v)=>handleGrupoEmpresa({ ...grupoEmpresaSelecionado, GE: v, CNPJ: null })}
                renderInput={(params)=><TextField {...params} label="Grupo Econômico" />}
              />
              {/* Empresa / CNPJ */}
              <Autocomplete
                value={grupoEmpresaSelecionado.CNPJ}
                size="small"
                sx={{ minWidth: 260, '& .MuiOutlinedInput-root': { borderRadius: '50px' } }}
                options={optionsGrupoEmpresas.CNPJ}
                isOptionEqualToValue={(o,v)=>o.id===v.id}
                getOptionLabel={(o)=>o.detalhes || ''}
                noOptionsText={grupoEmpresaSelecionado.GE ? 'Nenhuma empresa' : 'Selecione um grupo'}
                disabled={!grupoEmpresaSelecionado.GE}
                onChange={(_,v)=>handleGrupoEmpresa({ ...grupoEmpresaSelecionado, CNPJ: v })}
                renderInput={(params)=><TextField {...params} label="Empresa (CNPJ)" />}
              />
              {/* Busca texto */}
              <TextField
                size="small"
                sx={{ minWidth: 280, '& .MuiOutlinedInput-root': { borderRadius: '50px' } }}
                label="Buscar..."
                value={textoBusca}
                onChange={(e)=>{ setTextoBusca(e.target.value); handleDebounce(e.target.value); }}
                InputProps={{ startAdornment: <InputAdornment position='start'><SearchIcon sx={{ color:'#18316e' }}/></InputAdornment> }}
              />
            </Box>
          </Box>

          <ResumoCreditosPlanilha embedded />
        </Box>
      </Box>

      {cnpjSelecionado ? (
        <Fab
          sx={{
            background: "#4b6fc0",
            bottom: 40,
            right: 20,
            position: "fixed",
            zIndex: 1000,
            animation: `${pulse} 1.2s infinite ease-in-out`,
            "&:hover": { backgroundColor: "#fff" },
          }}
          aria-label="add"
          onClick={() => openInsertModal()}
        >
          <AddIcon />
        </Fab>
      ) : ("")}

      <Dialog fullWidth open={openModalForm} onClose={closeFormModal}>
        {loading ? (
          <Loading loading={loading} />
        ) : (
          <form onSubmit={handleSave}>
            <DialogTitle>{isEdit ? "Editar Fator" : "Inserir Fator"}</DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Fornecedor"
                    value={formFornecedor}
                    onChange={(e) => setFormFornecedor(e.target.value)}
                    fullWidth
                    size="small"
                    margin="normal"
                    disabled={isEdit ? true : false}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Código Produto"
                    value={formCodigoProduto}
                    onChange={(e) => setFormCodigoProduto(e.target.value)}
                    fullWidth
                    size="small"
                    margin="normal"
                    disabled={isEdit ? true : false}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="EAN"
                    value={formEAN}
                    onChange={(e) => setFormEAN(e.target.value)}
                    fullWidth
                    size="small"
                    margin="normal"
                    disabled={isEdit ? true : false}
                    required
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextField
                    label="Fator"
                    value={formFator}
                    onChange={(e) => setFormFator(e.target.value)}
                    fullWidth
                    size="small"
                    margin="normal"
                    required
                  />
                </Grid>
              </Grid>
            </DialogContent>

            <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
              <WhiteButton clickFunction={closeFormModal} textValue="Cancelar" contentIcon={<CloseIcon />} iconLeft />
              <BlueButton textValue="Salvar" type="submit" contentIcon={<SendIcon />} />
            </DialogActions>
          </form>
        )}
      </Dialog>
      <SnackBar objSnackBar={objSnackBar} setObjSnackBar={handleSnackBar} />
    </>
  );
};

export default PERDCOMP;
